import { DateTime } from 'luxon'
import { UserDocument } from '../lib/userDocuments.slice'
import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'

export type GroupedDocsEntry = {
  monthKey: string
  docs: UserDocument[]
}

export enum GroupByEnum {
  MonthWithinYear,
  CreatedAtYear,
  None,
  StatementYear,
  CategoryYear,
}

export const groupByType = (
  groupBy: GroupByEnum,
  documents: UserDocument[]
): Record<string, UserDocument[] | Record<string, UserDocument[]>> => {
  switch (groupBy) {
    // Bank Statements
    case GroupByEnum.StatementYear:
      return documents.reduce<Record<string, UserDocument[]>>((acc, doc) => {
        const rawMonth = doc.statementMonth ?? doc.statement?.statementMonth
        const year = rawMonth
          ? DateTime.fromFormat(
              rawMonth,
              DATE_FORMATS_LUXON.YEAR_MONTH
            ).year.toString()
          : new Date(doc.createdAt).getFullYear().toString()

        if (!acc[year]) acc[year] = []
        acc[year].push(doc)

        return acc
      }, {})

    // Bookkeeping
    case GroupByEnum.CreatedAtYear:
      return documents.reduce<Record<string, UserDocument[]>>((acc, doc) => {
        const year = new Date(doc.createdAt).getFullYear().toString()
        if (!acc[year]) acc[year] = []
        acc[year].push(doc)

        return acc
      }, {})

    // Taxes
    case GroupByEnum.CategoryYear:
      return documents.reduce<Record<string, UserDocument[]>>((acc, doc) => {
        const key = `${doc.category || 'Uncategorized'} - ${new Date(doc.createdAt).getFullYear()}`
        if (!acc[key]) acc[key] = []
        acc[key].push(doc)

        return acc
      }, {})

    // Receipts
    case GroupByEnum.MonthWithinYear:
      return documents.reduce<Record<string, Record<string, UserDocument[]>>>(
        (acc, doc) => {
          const date = new Date(doc.createdAt)
          const year = date.getFullYear().toString()
          const month = date.toLocaleString('default', { month: 'long' })
          const key = `${year}`
          if (!acc[key]) acc[key] = {}
          if (!acc[key][month]) acc[key][month] = []
          acc[key][month].push(doc)

          return acc
        },
        {}
      )

    // Incorporation | Other
    case GroupByEnum.None:
    default:
      return { All: documents }
  }
}
